// extracted by mini-css-extract-plugin
export var actionText = "_rn-4";
export var container = "_rn-0";
export var leftSection = "_rn-1";
export var rightSection = "_rn-2";
export var settingsButton = "_rn-6";
export var settingsIcon = "_rn-7";
export var shortcut = "_rn-5";
export var shortcutGroup = "_rn-3";